import { usePlayerActions } from "@utils/player/core/usePlayer";
import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LPressable from "@components/LPressable";
import { getViewPort } from "@utils/web/config";
import { useCallback, useState } from "react";
import { useWindowDimensions } from "react-native";
import { useActiveQueue } from "@utils/player";

const ArrowButton = ({
  type,
  isFirstSong,
  isLastSong,
  onPress,
}: {
  type: "up" | "down";
  isFirstSong: boolean;
  isLastSong: boolean;
  onPress: () => void;
}) => {
  const arrowColor =
    type === "up"
      ? isFirstSong
        ? "#9399A350"
        : "white"
      : isLastSong
        ? "#9399A350"
        : "white";

  const [hovered, setHovered] = useState(false);
  const bgColor = hovered ? "#0d0d0d80" : "#0d0d0d50";
  return (
    <LBox
      style={{
        backgroundColor: bgColor,
        borderRadius: 999,
        padding: 8,
      }}
      onPointerEnter={() => {
        if (type === "up" && isFirstSong) {
          return;
        }
        if (type === "down" && isLastSong) {
          return;
        }
        setHovered(true);
      }}
      onPointerLeave={() => {
        setHovered(false);
      }}
    >
      <LPressable
        sentryEventName={`web_feed_controls_${type}`}
        onPress={onPress}
      >
        <LIcon
          colors={{ color: arrowColor }}
          name="chevron"
          rotate={type === "up" ? 180 : 0}
          size={50}
        />
      </LPressable>
    </LBox>
  );
};

const WebFeedControls = () => {
  const playerActions = usePlayerActions();

  const window = useWindowDimensions();
  const { isLargeScreen } = getViewPort(window);
  const activeQueue = useActiveQueue();
  const playFromQueueItem = playerActions.playFromQueueItem;
  const items = activeQueue?.items ?? [];
  const activeSongIndex = activeQueue?.currentIndex ?? -1;
  const isFirstSong = activeSongIndex <= 0;
  const isLastSong = activeSongIndex === items.length - 1;

  const onDownPress = useCallback(() => {
    if (activeSongIndex < 0) return;
    const next = items[activeSongIndex + 1];
    if (!next) return;
    playFromQueueItem(next.qid, { autoPlay: true });
  }, [activeSongIndex, items, playFromQueueItem]);

  const onUpPress = useCallback(() => {
    if (activeSongIndex < 0) return;
    const prev = items[activeSongIndex - 1];
    if (!prev) return;
    playFromQueueItem(prev.qid, { autoPlay: true });
  }, [activeSongIndex, items, playFromQueueItem]);

  if (!isLargeScreen) {
    return null;
  }
  if (
    !activeQueue ||
    activeQueue.type !== "foryou" ||
    items.length === 0 ||
    activeSongIndex < 0
  ) {
    return null;
  }

  return (
    <LBox
      style={{
        position: "absolute",
        right: 0,
        width: 100,
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
      }}
      pointerEvents="box-none"
    >
      <ArrowButton
        type="up"
        isFirstSong={isFirstSong}
        isLastSong={isLastSong}
        onPress={onUpPress}
      />
      <ArrowButton
        type="down"
        isFirstSong={isFirstSong}
        isLastSong={isLastSong}
        onPress={onDownPress}
      />
    </LBox>
  );
};

export default WebFeedControls;
